import { Stack } from '@mui/material';

import { HouseholdChatModeSelector } from './HouseholdChatModeSelector';
import { HouseholdChatPersonaSelector } from './HouseholdChatPersonaSelector';

interface HouseholdChatComposerLeadingActionsProps {
  chatModesEnabled: boolean;
  personaSelectorEnabled: boolean;
}

export function HouseholdChatComposerLeadingActions({
  chatModesEnabled,
  personaSelectorEnabled,
}: HouseholdChatComposerLeadingActionsProps) {
  if (!chatModesEnabled && !personaSelectorEnabled) {
    return null;
  }

  return (
    <Stack direction="row" alignItems="center" gap={1}>
      {chatModesEnabled && <HouseholdChatModeSelector />}
      {personaSelectorEnabled && <HouseholdChatPersonaSelector />}
    </Stack>
  );
}
